module.exports = __webpack_public_path__ + "media/images/restaurant/areas/okinawa_m-5fbbc029455f8403dacdd0f7576f1585.png";